import React from "react";
import Container from "../container";

const OwnerRewards = () => {
  return (
    <div className="mt-20">
      <Container className="max-w-[1200px] z-20">
        <div>
          <div className="">
            <p className="uppercase text-30 font-extraBold">Owner Rewards</p>
            <p className="font-normal text-18 text-white my-6">
              Earn rewards by holding NFTs’ Avatars, and LANDS
            </p>
          </div>
          {/* NFT Owner box  */}
          <div className="NFTOwnerBox ">
            <div className=" flex ">
              <div className="category">
                <div className="w-44 md:w-52 ">
                  <div className="bg-[#044C6B] mb-2 rounded-md ">
                    <p className="text-center font-extraBold text-18 text-white">
                      Level
                    </p>
                  </div>
                  <div className="bg-[#061E42] pt-14 rounded-5 ">
                    <div className="flex items-center justify-center">
                      <img
                        className=" w-[97px] h-[79px]"
                        src="/images/glass.png"
                        alt="nft owner"
                      />
                    </div>
                    <div className="mt-11 pb-3">
                      <p className="text-0 font-extraBold text-center text-white uppercase">
                        nft owner
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="boxes gap-44 grid grid-cols-6  md:w-full overflow-scroll md:overflow-visible">
                <div className="w-[170px] md:w-48">
                  <div className=" bg-[#044C6B]  mb-2 rounded-md ml-[15px]">
                    <p className="text-center font-extraBold text-18 text-white">
                      10
                    </p>
                  </div>
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3 ">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className=" bg-[#044C6B] ml-[15px] mb-2 rounded-md">
                    <p className="text-center font-extraBold text-18 text-white">
                      20
                    </p>
                  </div>
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#044C6B]  mb-2 rounded-md ml-[15px]">
                    <p className="text-center font-extraBold text-18 text-white">
                      30
                    </p>
                  </div>
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5 m">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#044C6B]  mb-2 rounded-md ml-[15px]">
                    <p className="text-center font-extraBold text-18 text-white">
                      50
                    </p>
                  </div>
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#044C6B] ml-[15px] mb-2 rounded-md ">
                    <p className="text-center font-extraBold text-18 text-white">
                      75
                    </p>
                  </div>
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#044C6B] ml-[15px] mb-2 rounded-md ">
                    <p className="text-center font-extraBold text-18 text-white">
                      100
                    </p>
                  </div>
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Avatar Owner  box  */}
          <div className="AvatarOwner mt-[10px]">
            <div className="flex items-center">
              <div>
                <div className="w-44 md:w-52">
                  <div className="bg-[#061E42] pt-14  rounded-5">
                    <div className="flex items-center justify-center">
                      <img
                        className=" w-[97px] h-[79px]"
                        src="/images/avarerOwner.png"
                        alt="nft owner"
                      />
                    </div>
                    <div className="mt-11 pb-3">
                      <p className="text-0 font-extraBold text-center text-white uppercase">
                        avatar owner
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" md:w-full gap-44 grid grid-cols-6 overflow-scroll md:overflow-visible">
                {/*category-1 end */}
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Land Owner  box  */}
          <div className="LandOwner mt-[10px]">
            <div className="flex items-center">
              <div>
                <div className="w-44 md:w-52">
                  <div className="bg-[#061E42] pt-14  rounded-5">
                    <div className="flex items-center justify-center">
                      <img
                        className=" w-[97px] h-[79px]"
                        src="/images/landOwner.png"
                        alt="nft owner"
                      />
                    </div>
                    <div className="mt-11 pb-3">
                      <p className="text-0 font-extraBold text-center text-white uppercase">
                        avatar owner
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" md:w-full gap-44 grid grid-cols-6 overflow-scroll md:overflow-visible">
                {/*category-1 end */}
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
                <div className="w-[170px] md:w-48">
                  <div className="bg-[#061E42] ml-[15px]">
                    <div className="flex items-center justify-center pt-14 rounded-5">
                      <img
                        className=" w-[86px] h-[82px] "
                        src="/images/goldBag.png"
                        alt=""
                      />
                    </div>
                    <div className="flex items-center justify-center mt-7 pb-3">
                      <img
                        className=" w-[24px] h-[24px] "
                        src="/images/singleCoin.png"
                        alt=""
                      />
                      <p className="text-24 text-center text-white">10</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OwnerRewards;
